import React from 'react';
import FieldContents from './FieldContents';
import type Field from 'components/CardLayoutEditor/models/Field';

interface ExampleFieldProps {
  field: Field;
}

const ExampleField: React.FC<ExampleFieldProps> = ({ field }) => {
  let contents;
  if (typeof field.exampleContents === 'function') {
    // It's a function, so call it
    contents = field.exampleContents();
  } else {
    // It's not a function, handle accordingly
    // Need to handle different types of fields within the set here
    contents = field.fields[0].exampleContents();
  }

  return <FieldContents contents={contents} />;
};

export default ExampleField;
